'use strict';

const APP_STORE = 'https://apps.apple.com/app/id1451080877';
const PLAY_STORE = 'https://play.google.com/store/apps/details?id=online.lost.pet';
const FALLBACK_DELAY = 2500;

function getPlatform(navigator) {
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return 'android';
  // iPadOS can identify itself as a Mac when requesting desktop websites.
  if (/iPad|iPhone|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
  return 'desktop';
}

function getAppLinks(ticketId) {
  if (!/^[1-9]\d*$/.test(String(ticketId))) return null;
  const path = `ticket/${ticketId}`;
  return {
    deepLink: `lostpet://${path}`,
    android: `intent://${path}#Intent;scheme=lostpet;package=online.lost.pet;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE)};end`,
    appStore: APP_STORE,
  };
}

function initOpenApp(element, win = window) {
  const links = getAppLinks(element.dataset.ticketId);
  const button = element.querySelector('.js-open-app');
  if (!links || !button) return;
  const platform = getPlatform(win.navigator);
  if (platform === 'desktop') return;

  element.querySelector('.js-open-app-label').textContent = button.dataset.openLabel;
  // Keep the launch in the user's click: browsers can block delayed launches.
  button.href = platform === 'android' ? links.android : links.deepLink;
  if (platform === 'android') return;

  let timer = null;
  let pending = false;
  const doc = win.document;
  const stop = () => {
    pending = false;
    win.clearTimeout(timer);
    timer = null;
  };
  const fallback = () => {
    timer = null;
    if (!pending || doc.hidden) return stop();
    // A native confirmation dialog can temporarily take focus. Wait for it
    // instead of navigating away while the user decides whether to open the app.
    if (!doc.hasFocus()) return;
    stop();
    win.location.assign(links.appStore);
  };
  const schedule = () => {
    win.clearTimeout(timer);
    timer = win.setTimeout(fallback, FALLBACK_DELAY);
  };
  button.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    stop();
    pending = true;
    schedule();
    // The anchor's default action opens lostpet://ticket/<id>.
  });
  doc.addEventListener('visibilitychange', () => {
    if (doc.hidden) stop();
  });
  win.addEventListener('pagehide', stop);
  win.addEventListener('pageshow', stop);
  win.addEventListener('focus', () => {
    if (pending) schedule();
  });
}

module.exports = {initOpenApp, getAppLinks, getPlatform};
